module.exports = __webpack_public_path__ + "img/the usual offering box.2efa72d8.png";